import styled from '@emotion/styled';
import { Select } from 'antd';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';

import { changeSingleValueQuestionAnswer } from '../actions/surveysActions';
import { QuestionComponentBaseProps, SurveySelectQuestionAnswer } from '../models/surveys';
import { getProgramSurveySingleQuestionAnswer } from '../selectors/surveysSelectors';
import { QuestionHeader } from './QuestionHeader';

const StyledSelect = styled(Select)({
    width: '18.38rem',
    height: '2.63rem',
    '.ant-select-selection--single': {
        height: '2.63rem',
        padding: '0.35rem',
    },
});

interface StateProps {
    answer: SurveySelectQuestionAnswer | undefined;
}

interface ActionsProps {
    changeSingleValueQuestionAnswer: typeof changeSingleValueQuestionAnswer;
}

interface Props extends QuestionComponentBaseProps, StateProps, ActionsProps {
    options: string[];
}

export class SelectQuestionContainer extends React.PureComponent<Props> {
    private handleOptionChange = (value: string) => {
        const { programId, surveyId, id } = this.props;

        this.props.changeSingleValueQuestionAnswer({
            programId,
            surveyId,
            question: id,
            value,
        });
    };

    public render(): JSX.Element {
        const { question, placeholder, options, answer, readableIndex } = this.props;

        return (
            <>
                {question && <QuestionHeader index={readableIndex} header={question} />}
                <StyledSelect
                    placeholder={placeholder}
                    onChange={this.handleOptionChange}
                    value={answer && answer.data.content}
                >
                    {options.map(option => (
                        <Select.Option key={option} value={option}>
                            {option}
                        </Select.Option>
                    ))}
                </StyledSelect>
            </>
        );
    }
}

const mapStateToProps = (state: AppState, { programId, surveyId, id }: Props): StateProps => ({
    answer: getProgramSurveySingleQuestionAnswer(state, programId, surveyId, id) as
        | SurveySelectQuestionAnswer
        | undefined,
});

export const SelectQuestion = connect(mapStateToProps, {
    changeSingleValueQuestionAnswer,
})(SelectQuestionContainer);
